<template>
  <div
    v-loading="loading"
    element-loading-text="查询中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="fill-information-container"
  >
    <el-form label-width="140px" :rules="rules" :model="qszmFormData" ref="mainForm">
      <el-row type="flex" justify="center" :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名：" prop="qlrmc">
            <el-input v-model="qszmFormData.qlrmc" :disabled="flag"></el-input>
          </el-form-item>
          <el-form-item label="证件类型：" prop="zjzl">
            <dict-select v-model="qszmFormData.zjzl" type="证件种类" :disabled="flag"></dict-select>
          </el-form-item>
          <el-form-item label="证件号码：" prop="zjh">
            <el-input v-model="qszmFormData.zjh" :disabled="flag"></el-input>
          </el-form-item>
          <el-form-item label="办理网点：">
            <el-input v-model="blwd" disabled></el-input>
          </el-form-item>
          <el-form-item label="网点电话：">
            <el-input v-model="wddh" disabled></el-input>
          </el-form-item>
          <el-form-item label="网点地址：">
            <el-input v-model="wddz" disabled></el-input>
          </el-form-item>
          <!--          <el-form-item label="查档用途：">-->
          <!--            <dict-select-->
          <!--              v-model="qszmFormData.cxyt"-->
          <!--              type="查档用途"-->
          <!--            ></dict-select>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="是否抵押：">-->
          <!--            <el-radio-group v-model="qszmFormData.sfdy">-->
          <!--              <el-radio :label="true">是</el-radio>-->
          <!--              <el-radio :label="false">否</el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="是否查封：">-->
          <!--            <el-radio-group v-model="qszmFormData.sfcf">-->
          <!--              <el-radio :label="true">是</el-radio>-->
          <!--              <el-radio :label="false">否</el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </el-form-item>-->
        </el-col>
        <el-col :span="12" v-if="$hasPermission('IEBDC:SSYTJ') && !flag">
          <el-button class="read-id-card-button" type="primary" @click="getIdCardInfo">读取身份证信息</el-button>
          <div class="lc-name">
            <span
              >所选一体机编号为:
              {{ chooseDeviceInfo.deviceBh ? chooseDeviceInfo.deviceBh : chooseDeviceInfo.deviceIp }}</span
            >
          </div>
          <div class="rz_img">
            <img class="rz_img_id" :src="qszmFormData.idImage" style="width: 164px" />
            <img class="rz_img_face" :src="qszmFormData.faceImage" style="width: 164px" />
            <div class="re_img_gayz" v-show="qszmFormData.gayz">
              <img :src="qszmFormData.gayz_img" />
              <span>{{ qszmFormData.gayz }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="text-center">
      <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import { zxTemplate } from '@public/zsMould';
import hasPermission from '@iebdc/mixin/hasPermission';
import { localDataUser } from '@iebdc/utils/local-data';
import { mapGetters } from 'vuex';
import { bsdtDetail, checkCertifyInspect } from '@iebdc/api/qszmcx-service';
import { getInfoByDeviceBh } from '@iebdc/api/user-center/device.js';
// import {validateName, validateZjh, validatePhone} from 'iebdc/utils/validate';
import QszmCertificateTemplate from '../qszm-certificate-template';
import { getDeviceList } from '@iebdc/api/user-center/device.js';
import { getCookie } from '@iebdc/utils/cookies';
export default {
  name: 'fillInformation',
  mixins: [hasPermission],
  components: {
    QszmCertificateTemplate,
  },
  data() {
    this.rules = {
      qlrmc: [{ required: true, message: '请输入权利人名称', trigger: 'blur' }],
      zjh: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
      zjzl: [{ required: true, message: '请选择证件种类', trigger: 'change ' }],
    };
    return {
      tempalteList: zxTemplate,
      qszmFormData: {
        qqjgmc: this.selectedOrganizationsTitle,
        bdcqzh: '', // 不动产权证号
        qydm: getCookie('selectedAreaCode'), // 区域代码
        qlrmc: '', // 权利人名称
        zjzl: '', // 证件种类(身份证)
        zjh: '', // 证件号(一般是身份证号)
        loginName: '',
        idImage: require('../../../assets/images/qszm/idimg.png'),
        faceImage: require('../../../assets/images/qszm/faceimg.png'),
        cxyt: '', // 查档用途
        sfdy: true, // 是否抵押
        sfcf: true, // 是否查封
      },
      blwd: '', // 办理网点
      wddh: '', // 网点电话
      wddz: '', // 网点地址
      // cxjgTitle: '',
      // xianTitle: '',
      // bsdtTitle: '',
      loading: false,
      chooseDeviceInfo: {},
      flag: false,
      user: localDataUser.get(),
    };
  },
  computed: {
    ...mapGetters([
      'selectedOrganizationsTitle',
      'selectedAreaTitle',
      'selectedBsdtTitle',
      'selectedBsdtCode',
      'selectedOrganizationsCode',
    ]),
  },
  watch: {
    selectedBsdtCode() {
      this.getBsdtDetail();
    },
  },
  mounted() {
    if (!JSON.parse(localStorage.getItem('chooseDeviceInfo'))) {
      //缓存中没有值的时候执行接口获取之前选择的设备
      this.getDevice();
    } else {
      //有值直接获取存储中的值
      this.chooseDeviceInfo = JSON.parse(localStorage.getItem('chooseDeviceInfo'));
    }
    this.blwd = this.selectedOrganizationsTitle;
    this.getBsdtDetail();
    let loginName = JSON.parse(localStorage.getItem('IEBDC_USER_DATA')).loginName;
    this.qszmFormData.loginName = loginName;
    if (this.user.userCategory === 'NORMAL') {
      this.flag = true;
      this.qszmFormData.qlrmc = this.user.name;
      this.qszmFormData.zjzl = this.user.zjzl;
      this.qszmFormData.zjh = this.user.zjh;
    } else {
      this.flag = false;
    }
  },
  methods: {
    getDevice() {
      getDeviceList({ deviceUser: this.user.id }).then((res) => {
        if (res.success && res.data) {
          res.data.forEach((item, index) => {
            if (item.defaultStatus === 0) {
              this.$set(this.chooseDeviceInfo, 'deviceBh', res.data[index].deviceBh);
              this.$set(this.chooseDeviceInfo, 'deviceIp', res.data[index].deviceIp);
              this.$set(this.chooseDeviceInfo, 'deviceId', res.data[index].id);
              localStorage.setItem('chooseDeviceInfo', JSON.stringify(this.chooseDeviceInfo));
            }
          });
        }
      });
    },
    // 验证表单
    submit() {
      if (!this.selectedBsdtCode) {
        this.$message.warning('请选择办事大厅!');
        return;
      }
      this.$refs.mainForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = { ...this.qszmFormData };
          params.qlrmc=params.qlrmc?this.$encryptByDES(params.qlrmc):'';
          params.zjh=params.zjh?this.$encryptByDES(params.zjh):'';
          params.loginName=params.loginName?this.$encryptByDES(params.loginName):'';

          checkCertifyInspect(params)
            .then((res) => {
              if (res.data) {
                this.loading = false;
                this.$emit('qszmcdbh', res.data);
                this.$emit('next', 2);
              } else {
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    // 获取办事大厅信息
    getBsdtDetail() {
      this.blwd = this.selectedOrganizationsTitle || '';
      // 获取办事大厅详情
      bsdtDetail({ officeCode: this.selectedBsdtCode }).then((res) => {
        if (res.success && res.data) {
          this.wddh = res.data.dh;
          this.wddz = res.data.address;
        }
      });
    },
    //身份证信息读取 一体机
    getIdCardInfo() {
      //判断是否已经选择一体机机器型号
      if (this.chooseDeviceInfo.deviceId) {
        let deviceBh = this.chooseDeviceInfo.deviceBh ? this.chooseDeviceInfo.deviceBh : this.chooseDeviceInfo.deviceId;
        //直接获取身份证
        getInfoByDeviceBh({ deviceBh: deviceBh }).then((res) => {
          if (res.success) {
            const result = res.data;
            if (!result) {
              this.$message.error('请确认选择机型编码是否正确,或信息失效');
              return false;
            }
            if (result.dataStatus === '0') {
              this.$message.error('信息失效');
              return false;
            }
            if (result.verifyResult === 0 || result.verifyResult === '0') {
              this.sqrData.qlrmc = result.name;
              this.sqrData.ywrmc = result.name;
              this.sqrData.zjzl = '1';
              this.sqrData.zjh = result.cardNo;
              this.sqrData.idImage = result.idImage;
              this.sqrData.faceImage = result.faceImage;
              if (result.mopsGmsfhmResult === '一致' && result.mopsXmResult === '一致') {
                this.sqrData.gayz_img = require('@iebdc/assets/images/gayz-success.png');
                this.sqrData.gayz = '实名认证成功';
              } else {
                this.sqrData.gayz_img = require('@iebdc/assets/images/gayz-fail.png');
                this.sqrData.gayz = '实名认证失败';
              }
              this.$refs.form.setData(this.sqrData);
            } else {
              this.$message.error('实名认证失败');
            }
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error('请前往用户中心选择一体机编号！');
      }
    },
    //添加家庭关系
    // addRelationship() {
    //   this.dynamicValidateForm.familyMemberList.push({
    //     xm: '',
    //     zjzl: userInfo.zjzl,
    //     zjh: '',
    //     memberShip: '',
    //   });
    // },
    // deleteMsg(index) {
    //   this.dynamicValidateForm.familyMemberList.splice(index, 1);
    // },
    // 查询证书
    // qszmCheck() {
    //   // 处理数组中是值是对象时的格式
    //   const copyFamilyMemberList = [...this.userRzRegister.familyMemberList];
    //   delete this.userRzRegister.familyMemberList;
    //   for (let i = 0, len = copyFamilyMemberList.length; i < len; i++) {
    //     const obj = copyFamilyMemberList[i];
    //     for (const key in obj) {
    //       this.userRzRegister[`familyMemberList[${i}].${key}`] = obj[key];
    //     }
    //   }
    //   qszmCheck(this.userRzRegister).then((res) => {
    //     if (res && res.success) {
    //       this.$emit('next', 2);
    //     }
    //   });
    // }
  },
};
</script>

<style lang="scss" scoped>
.fill-information-container {
  // background-color: #ffffff;
  padding: 20px 140px;

  .lc-name {
    color: orange;
    margin-top: 20px;
  }

  .rz_img {
    margin-top: 10px;

    .rz_img_face {
      margin-left: 20px;
    }
  }

  /*
  .main-box {
    .header {
      height: 42px;
      line-height: 42px;
      background-color: rgba(242, 246, 252, 1);
      color: rgba(16, 16, 16, 1);
      font-size: 14px;
      text-align: left;
      font-family: Microsoft Yahei;

      span {
        margin-left: 10px;
      }
    }

    .body {
      border: 1px solid #dcdcdc;
      padding: 30px 10px;
      margin-bottom: 40px;
    }

    .member-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
   */

  /deep/ .el-select {
    width: 100%;
  }
}
</style>
